<template>
  <div id="print">
    <header class="print:hidden">
      <nav class="text-right">
        <Button size="lg" class="inline-flex items-center" @click="print">
          <PrinterIcon class="mr-1 size-5 text-white" aria-hidden="true" />
          {{ $t('general.print') }}
        </Button>
      </nav>
    </header>
    <br />
    <slot />
  </div>
</template>

<script lang="ts">
export const printInjectionKey = Symbol() as InjectionKey<{
  print: () => void;
}>;
</script>

<script lang="ts" setup>
import { PrinterIcon } from '@heroicons/vue/20/solid';

const i18n = useI18n();

useHead({
  title: i18n.t('general.print-view') + ' | Rollouter',
});

const print = () => {
  const prevTitle = document.title;
  document.title = '⠀'; // Remove title from print view header
  window.print();
  document.title = prevTitle;
};

provide(printInjectionKey, {
  print,
});
</script>

<style>
table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
thead {
  display: table-header-group;
}
tfoot {
  display: table-footer-group;
}

@page {
  size: auto;
  margin: 20mm 10mm 10mm 10mm;
}

body {
  margin: 0;
  padding: 0;
}
@media screen {
  body {
    padding: 20mm 10mm 10mm 10mm;
  }
}

#print .tableBorder,
#print .grid {
  background-color: #fff;
  width: 100%;
  border-collapse: collapse;
}

#print .tableBorder td,
#print .grid td {
  vertical-align: top;
  padding: 2px;
  border: 1px solid #ccc;
}

#print .noPadding {
  padding: 0 !important;
}

#print h3 .subText {
  font-size: 60%;
  font-weight: normal;
}

#print .tabLabel {
  font-weight: bold;
  border: 1px solid #ccc;
  border-bottom: none;
  padding: 2px;
  display: inline;
}

#print td.blank {
  padding: 0;
  margin: 0;
}

#print .blank td {
  border: none;
}

#print #descriptionArea {
  margin: 0;
  padding: 2px;
  border: 1px solid #ccc;
}

#print hr {
  border-top: 1px solid #aaa;
}
</style>
